import type { EqmsController } from "../../../controllers/useEqms";
import { WORK_AREA_LABEL } from "../../../models/eqms";

// 위험관리: 백엔드 API가 아직 없는 정직한 준비 중 안내 화면. 가짜 데이터/미구현 엔드포인트 호출 없음.
export function EqmsRiskView({ eqms }: { eqms: EqmsController }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "48px 16px" }}>
      <div className="info-card" style={{ maxWidth: 480, textAlign: "center" }}>
        <h4>위험관리</h4>
        <p>
          위험관리 기능은 준비 중입니다 (백엔드 미구현).
          {eqms.workArea && (
            <>
              <br />
              대상 워크 영역: {WORK_AREA_LABEL[eqms.workArea]}
            </>
          )}
        </p>
      </div>
    </div>
  );
}
